/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Errorsubmitting1Inputs */

const id_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesalahan mengirim ulasan`)
};

const ms_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat menghantar ulasan`)
};

const da_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejl ved indsendelse af anmeldelse`)
};

const de_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Einreichen der Bewertung`)
};

const en_us2_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error submitting review`)
};

const es_es2_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al enviar la reseña`)
};

const es_mx2_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al enviar la reseña`)
};

const fil_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error sa pagsusumite ng review`)
};

const fr_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la soumission de l'avis`)
};

const it_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore nell'invio della recensione`)
};

const hu_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba az értékelés beküldésekor`)
};

const nl_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout bij indienen review`)
};

const no_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feil ved innsending av omtale`)
};

const pl_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd wysyłania recenzji`)
};

const pt_br2_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error submitting review`)
};

const pt_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao enviar avaliação`)
};

const ro_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare la trimiterea recenziei`)
};

const fi_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virhe arvostelun lähetyksessä`)
};

const sv_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel vid inskickning av recension`)
};

const vi_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi khi gửi đánh giá`)
};

const tr_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorum gönderilirken hata oluştu`)
};

const cs_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba při odesílání recenze`)
};

const bg_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грешка при изпращане на ревю`)
};

const ru_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при отправке обзора`)
};

const uk_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка надсилання відгуку`)
};

const ar_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ في إرسال المراجعة`)
};

const hi_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबमिट करने में त्रुटि`)
};

const th_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาดในการส่งรีวิว`)
};

const ja_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビューの送信エラー`)
};

const zh_cn2_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error submitting review`)
};

const zh_hant1_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error submitting review`)
};

const ko_forms_review_errorsubmitting1 = /** @type {(inputs: Forms_Review_Errorsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error submitting review`)
};

/**
* | output |
* | --- |
* | "Error submitting review" |
*
* @param {Forms_Review_Errorsubmitting1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_errorsubmitting1 = /** @type {((inputs?: Forms_Review_Errorsubmitting1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Errorsubmitting1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_errorsubmitting1(inputs)
	if (locale === "ms") return ms_forms_review_errorsubmitting1(inputs)
	if (locale === "da") return da_forms_review_errorsubmitting1(inputs)
	if (locale === "de") return de_forms_review_errorsubmitting1(inputs)
	if (locale === "en-US") return en_us2_forms_review_errorsubmitting1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_errorsubmitting1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_errorsubmitting1(inputs)
	if (locale === "fil") return fil_forms_review_errorsubmitting1(inputs)
	if (locale === "fr") return fr_forms_review_errorsubmitting1(inputs)
	if (locale === "it") return it_forms_review_errorsubmitting1(inputs)
	if (locale === "hu") return hu_forms_review_errorsubmitting1(inputs)
	if (locale === "nl") return nl_forms_review_errorsubmitting1(inputs)
	if (locale === "no") return no_forms_review_errorsubmitting1(inputs)
	if (locale === "pl") return pl_forms_review_errorsubmitting1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_errorsubmitting1(inputs)
	if (locale === "pt") return pt_forms_review_errorsubmitting1(inputs)
	if (locale === "ro") return ro_forms_review_errorsubmitting1(inputs)
	if (locale === "fi") return fi_forms_review_errorsubmitting1(inputs)
	if (locale === "sv") return sv_forms_review_errorsubmitting1(inputs)
	if (locale === "vi") return vi_forms_review_errorsubmitting1(inputs)
	if (locale === "tr") return tr_forms_review_errorsubmitting1(inputs)
	if (locale === "cs") return cs_forms_review_errorsubmitting1(inputs)
	if (locale === "bg") return bg_forms_review_errorsubmitting1(inputs)
	if (locale === "ru") return ru_forms_review_errorsubmitting1(inputs)
	if (locale === "uk") return uk_forms_review_errorsubmitting1(inputs)
	if (locale === "ar") return ar_forms_review_errorsubmitting1(inputs)
	if (locale === "hi") return hi_forms_review_errorsubmitting1(inputs)
	if (locale === "th") return th_forms_review_errorsubmitting1(inputs)
	if (locale === "ja") return ja_forms_review_errorsubmitting1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_errorsubmitting1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_errorsubmitting1(inputs)
	return ko_forms_review_errorsubmitting1(inputs)
});
export { forms_review_errorsubmitting1 as "forms.review.errorSubmitting" }